import { render } from "./NfseServiceMunicipalProfiles.vue?vue&type=template&id=47492948"
import script from "./NfseServiceMunicipalProfiles.vue?vue&type=script&lang=js"
export * from "./NfseServiceMunicipalProfiles.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__